import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-not-found-redirect',
	standalone: true,
	template: '',
})
export class NotFoundRedirectComponent {
	constructor() {
		const router = inject(Router);
		// Get the attempted URL (full path)
		const attemptedUrl = window.location.pathname + window.location.search + window.location.hash;
		// Redirect to 404 page with attempted URL as query param
		router.navigate(['/404'], { queryParams: { url: attemptedUrl } });
	}
}
